import { useMemo } from "react";

import { Switch, type SwitchProps } from "../../../atoms/Form";

export const FIELD_NAME_IS_SEARCHABLE = "isSearchable";

const tLabel = "Searchable?";

export type IsSearchableProps = Pick<SwitchProps, "initialValue"> & { useDefault?: boolean };

export const IsSearchable = ({ initialValue, useDefault = true }: IsSearchableProps & { useDefault?: boolean }) => {
  const defaultInitialValue = useMemo(() => [FIELD_NAME_IS_SEARCHABLE], []);
  return (
    <Switch
      initialValue={useDefault ? defaultInitialValue : initialValue}
      name={FIELD_NAME_IS_SEARCHABLE}
      switches={[
        {
          formControlLabelProps: { label: tLabel, sx: { height: "2rem" } },
          switchProps: { name: FIELD_NAME_IS_SEARCHABLE },
        },
      ]}
    />
  );
};
